const numberFormatter = new Intl.NumberFormat(undefined, {
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

export const formatNumber = (value: number): string => numberFormatter.format(value);

export const getDateLabel = (date: Date, mode: 'month' | 'year'): string => {
  if (mode === 'year') {
    return date.getFullYear().toString();
  }

  return `${date.toLocaleString(undefined, { month: 'short' })} ${date.getFullYear()}`;
};
